import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import TYPES from '../util/types';

export interface ICache {
    add: (key: string | symbol, value: unknown) => void;
    get: (key: string | symbol) => unknown;
}

export interface ICacheController {
    getAssociatedCache: (associatedObject: unknown) => ICache | null;
    getGlobalCache: () => ICache;
}

export function injectCache(container: IContainer = injectOrBuildContainer()): ICache {
    return container.get<ICache>(TYPES.ICache);
}

export function bindCache(val: ICache, container: IContainer = injectOrBuildContainer()): void {
    container.bind<ICache>(TYPES.ICache, val);
}

export function unbindCache(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.ICache);
}

export function injectCacheController(
    container: IContainer = injectOrBuildContainer(),
): ICacheController {
    return container.get<ICacheController>(TYPES.ICacheController);
}

export function bindCacheController(
    val: ICacheController,
    container: IContainer = injectOrBuildContainer(),
): void {
    container.bind<ICacheController>(TYPES.ICacheController, val);
}

export function unbindCacheController(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.ICacheController);
}
